import { api_GET, api_POST, api_PUT } from "./_api";

const cnae_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Cnae/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Cnae/GetListAtivos`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Cnae/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Cnae`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Cnae`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
}
export default cnae_api;
